import { styled } from '@linaria/react';
import Image from 'next/image';

import { MqTablet } from '~theme/media';

export const Container = styled.div`
	position: fixed;
	z-index: 2;
	right: -20px;
	bottom: 120px;
	display: flex;
	width: 200px;
	height: 200px;
	align-items: center;
	justify-content: center;
	pointer-events: none;

	${MqTablet} {
		top: 280px;
		right: 0;
		bottom: 0;
	}

	&:hover {
		filter: drop-shadow(2px 2px 8px var(--color-white-m));
	}
`;

export const ClickableArea = styled.button`
	width: 120px;
	height: 120px;
	pointer-events: auto;
	touch-action: manipulation;
`;

export const PromoEventImage = styled(Image)`
	position: absolute;
`;
